export const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1);  // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2)
        ;
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
}

const deg2rad = (deg) => {
    return deg * (Math.PI / 180)
}

export const getAddressCombinedString = (store) => {
    return store.storeAddress + " , " + store.storePostalCode + " " + store.storeCity;
}

export const filterStoresBasedOnInput = (stores, input) => {
    const storesFiltered = stores.filter(item => {
        const lowerCaseInput = input.toLowerCase();
        if (item.storeName.toLowerCase().indexOf(lowerCaseInput) > -1 || item.storeAddress.toLowerCase().indexOf(lowerCaseInput) > -1 
        || item.storeCity.toLowerCase().indexOf(lowerCaseInput) > -1 || item.storePostalCode.toLowerCase().indexOf(lowerCaseInput) > -1) {
          return true;
        } else {
          return false;
        }
      }); 
    return storesFiltered;  
}